// extracted by mini-css-extract-plugin
export default {"roomItem":"RoomItem_roomItem__UkG+P","name":"RoomItem_name__rDfjQ","intro":"RoomItem_intro__chuWb","pointer":"RoomItem_pointer__7ZaGg"};